import React from 'react';
import PropTypes from 'prop-types';
import { StatCard as StatCardUI } from 'xland-ui';

function StatCard({
  icon = null,
  title = null,
  value = 0,
  prevValue = null,
  tooltip = '',
  className = '',
  onClick = null,
  loading = false,
}) {
  return (
    <StatCardUI
      icon={icon}
      title={title}
      value={value}
      prevValue={prevValue}
      tooltip={tooltip}
      loading={loading}
      className={className}
      onClick={onClick}
    />
  );
}

StatCard.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.string,
  prevValue: PropTypes.number,
  value: PropTypes.any,
  tooltip: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
};

export default StatCard;
